/*
 * Vertic JS - Site functional wrapper
 * http://labs.vertic.com
 *
 * Copyright 2015, Vertic A/S
 *
 *
 * NAMING CONVENTIONS:
 * -------------------
 * Singleton-literals and prototype objects:  PascalCase
 *
 * Functions and public variables:            camelCase
 *
 * Global variables and constants:            UPPERCASE
 *
 * Private variables:                         _underscorePrefix
 */

import _ from 'underscore';
import Handlebars from 'handlebars';

// Framework
import hbsHelpers from '../../server/helpers/hbs';

// Application
import App from './core/app';
import Lazy from './framework/vanillaLazyLoad';

// Polyfill, Support for forEach function on NodeLists
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

// Polyfill, Support for .closest and .matches in IE
if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) {
	Element.prototype.closest = function closest(s) {
		let el = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

window.submittedHubspotForms = [];

function hubSpotForSubmitted(formId) {
	let formIdMatch = false;
	window.submittedHubspotForms.forEach((item) => {
		if (item === event.data.id) {
			formIdMatch = true;
		}
	});
	if (!formIdMatch) {
		window.submittedHubspotForms.push(formId);
		return false;
	}
	return true;
}

// Add HubSpot listeners
window.addEventListener('message', (event) => {
	if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
		App.modal.create({
			type: 'generic-signup-complete',
			model: {
				thankYouModal: window.thankYouModal,
			},
		});

		if (window.gtmDataSubmit) {
			dataLayer.push(window.gtmDataSubmit);
		}

		if (window.gtmDataMarketingCheckboxChecked) {
			dataLayer.push(window.gtmDataSubmitMarketing);
		}
	}
});

// Registering handlebars helpers
_.each(hbsHelpers, (helper, key) => {
	Handlebars.registerHelper(key, helper);
});

// Document ready
function ready(fn) {
	if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

ready(() => {
	App.start();
	Lazy.load('.lazy');
});
